var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAuroraBc = function SvgAuroraBc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0019 10.5694C50.6236 10.5579 53.9374 12.605 55.5481 15.8489L82.4231 69.5989C83.9054 72.5611 83.7479 76.0798 82.0068 78.8977C80.2656 81.7157 77.1893 83.4306 73.8769 83.4306H20.1269C16.8144 83.4306 13.7381 81.7157 11.997 78.8977C10.2558 76.0798 10.0983 72.5611 11.5806 69.5989L38.4556 15.8489C40.0663 12.605 43.3801 10.5579 47.0019 10.5694ZM47.0019 4C40.8948 4 35.3113 7.44879 32.5789 12.9106L5.70394 66.6606C3.20315 71.6594 3.4695 77.5968 6.40784 82.3517C9.34618 87.1066 14.5373 90 20.1269 90H73.8769C79.4664 90 84.6576 87.1066 87.5959 82.3517C90.5342 77.5968 90.8006 71.6594 88.2998 66.6606L61.4248 12.9106C58.6924 7.44879 53.109 4 47.0019 4Z",
    fill: "white",
    fillOpacity: 0.2
  })));
};

export { SvgAuroraBc as ReactComponent };
export default __webpack_public_path__ + "41828208f12a2688a79fb82d91a11b97.svg";